/**
 * @desc: 抽取出一下组件公共方法，混合到组件
 * @author: zengtiansheng
 * @update: 2018/3/15
 */
export const dialogMixin = {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisibleShow: {
      get: function () {
        return this.dialogVisible
      },
      set: function (v) {
        this.$emit('update:dialogVisible', false)
      }
    }
  },
  methods: {
    validateForm(formRef, callBack) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          callBack()
        } else {
          return false
        }
      })
    }
  }
}
export const tabListMixin = {
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const loading = this.$loading({target: '#J_content_table'})
      Object.keys(this.searchData).forEach(item => {
        if (!this.searchData[item]) {
          delete this.searchData[item]
        }
      })
      const res = await this.$axios(this.APILIST, this.searchData)
      loading.close()
      if (res.success) {
        this.resData = res.data
      }
    },
    handleSizeChange(val) {
      this.searchData.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.searchData.pageNum = val
      this.getData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js